import { Vue, Component } from "vue-property-decorator";
import { namespace, Action, Getter } from "vuex-class";

import { storeModules } from "../../../store";
import { SOCKET_METHOD, SOCKET_RECEIVE_MESSAGE_TYPES } from "../../../common/socket.constants";
import { CommonServices } from "../../../services/common.services";
import { IAuthConfigModel } from "../../../models/user/auth-config.model";

const AppConfigAction = namespace(storeModules.AppConfig, Action);
const UserGetter = namespace(storeModules.User, Getter);
const UserAction = namespace(storeModules.User, Action);

@Component({
    // template: `<el-button @click="test()">Test update config</el-button>`
})
export default class AppConfigListener extends Vue {
    @AppConfigAction private updateConfigValue: (config: {key: string, value: string}) => void;
    @UserAction private updateUserConfig: (payload: { keyChain: string, value: any }) => void;
    @UserGetter authConfig: IAuthConfigModel;
    
    private commonService = new CommonServices();
    private authConfigKeys: string[] = null;
    private keyify(obj, prefix = '') {
        if (obj === null || obj === undefined) {
            return [];
        }

        return Object.keys(obj).reduce((res, el) => {
            if( Array.isArray(obj[el]) ) {
                return res;
            } else if( typeof obj[el] === 'object' && obj[el] !== null ) {
                return [...res, ...this.keyify(obj[el], prefix + el + '.')];
            } else {
                return [...res, prefix + el];
            }
            }, []);
    }
        
    private updateConfigKeyStore(configs) {
        console.log('updateConfigKeyStore: ', configs);

        if(configs === null || configs === undefined )
            return;

        const keys = Object.keys(configs);
        if (!this.authConfigKeys) {
            const keyChain = this.keyify(this.authConfig || {});
            this.authConfigKeys = keyChain
        }
       
        for (let key of keys) {
            const keyAuthConfig = this.authConfigKeys.find((item => {
               return item.indexOf(key) > -1;
            }))
            if (keyAuthConfig) {
                this.updateUserConfig({
                    keyChain:keyAuthConfig,
                    value: configs[key]
                })
                console.log('update to user config key chain: ', keyAuthConfig);
            } else {
                this.updateConfigValue({
                    key: key,
                    value: configs[key]
                })
            }
        }
    }
    private handleChangeSystemConfig(data: string[]) {
        console.log('handleChangeSystemConfig: ', data);
        const configKeys = data || [];
        if (configKeys.length > 0) {
            this.commonService.getConfigDataByKey({
                systemConfigKeys: configKeys,
                userConfigKeys: []
            }).then(res => {
                this.updateConfigKeyStore(res.SystemConfigs || {});
            })
        }

    }

    private handleChangeUserConfig(data: string[]) {
        console.log('handleChangeUserConfig: ', data);
        const configKeys = data || [];
        if (configKeys.length > 0) {
            this.commonService.getConfigDataByKey({
                systemConfigKeys: [],
                userConfigKeys: configKeys
            }).then(res => {
                this.updateConfigKeyStore(res.UserConfigs || {});
            })
        }
    }
    
    mounted() {
        this.$socket.onEvent(SOCKET_METHOD.RECEIVE_MESSAGE, ({ name, data }) => {
            console.log(`Socket onEvent: ${SOCKET_METHOD.RECEIVE_MESSAGE} - payload: ${name} - ${data}`);
            switch(name) {
                case SOCKET_RECEIVE_MESSAGE_TYPES.SYSTEM_CONFIG:
                    this.handleChangeSystemConfig(data);
                    break;
                case SOCKET_RECEIVE_MESSAGE_TYPES.USER_CONFIG:
                    this.handleChangeUserConfig(data);
                    break;
            }
        })
    }
    render() {
        return this.$slots.default;
    }
}